export const socialMedia = {
  en: {
    title: "Social Media Planning",
    subtitle: "Create and manage Instagram carousel posts with AI",
    refresh: "Refresh",
    createCarousel: "Create Carousel",
    create: "Create",
    postStats: "Post Statistics",
    scheduled: "Scheduled",
    drafts: "Drafts",
    ready: "Ready",
    published: "Published",
    scheduledPosts: "scheduled posts",
    draftPosts: "draft posts",
    readyPosts: "ready posts",
    publishedPosts: "published posts",
    tryAgain: "Try Again",
    publishToInstagram: "Publish to Instagram",
    publishNow: "Publish Now",
    viewOnInstagram: "View on Instagram",
    preview: "Preview",
    edit: "Edit",
    delete: "Delete",
    slides: "slides",
    at: "at",
    created: "Created",
    noPostsYet: "No posts yet. Create your first carousel!",
    createPost: "Create Post",
    deletePost: "Delete Post",
    deleteConfirm: "Are you sure you want to delete this post?",
    deleteCannotUndo: "This action cannot be undone.",
    publishing: "Publishing to Instagram...",
    publishSuccess: "Published to Instagram!",
    publishFailed: "Publishing failed",
    failedPublish: "Failed to publish post",
    viewOnIg: "Click to view on Instagram",
    cannotPublish: "Cannot publish",
    noImages: "This post has no images. Generate images first.",
    caption: "Caption",
    spanish: "Spanish",
    english: "English",
    posts: "Posts",
    loadingPosts: "Loading posts",
    socialMediaPosts: "Social media posts",
    untitledPost: "Untitled post",
    socialPostPreview: "Social post preview",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    refreshPosts: "Refresh posts",
    publishConfirmDesc: "to Instagram now? This will make it visible to your followers.",
    publishLabel: "Publish",
    postLive: "Your post is now live on Instagram.",
    failedPublishToInstagram: "Failed to publish to Instagram",
    statusDraft: "Draft",
    statusGenerating: "Generating",
    statusReady: "Ready",
    statusScheduled: "Scheduled",
    statusPublished: "Published",
    statusFailed: "Failed",
    daySun: "Sun",
    dayMon: "Mon",
    dayTue: "Tue",
    dayWed: "Wed",
    dayThu: "Thu",
    dayFri: "Fri",
    daySat: "Sat",
    monthJanuary: "January",
    monthFebruary: "February",
    monthMarch: "March",
    monthApril: "April",
    monthMay: "May",
    monthJune: "June",
    monthJuly: "July",
    monthAugust: "August",
    monthSeptember: "September",
    monthOctober: "October",
    monthNovember: "November",
    monthDecember: "December",
    // InstagramAccountsManager
    instagramAccounts: "Instagram Accounts",
    addAccount: "Add Account",
    addInstagramAccount: "Add Instagram Account",
    addAccountDesc: "Connect a new Instagram Business account for publishing.",
    displayName: "Display Name *",
    displayNamePlaceholder: "e.g., Solariis, Banger.bio",
    businessAccountId: "Instagram Business Account ID *",
    businessAccountIdPlaceholder: "e.g., 17841400...",
    findInBusinessSuite: "Find this in Facebook Business Suite → Instagram → Settings",
    accessToken: "Access Token *",
    accessTokenPlaceholder: "Long-lived access token",
    contentLanguage: "Content Language",
    brandContextCompany: "Brand Context (Company)",
    selectCompanyPlaceholder: "Select company...",
    noCompanyDefaults: "No company (use Solariis defaults)",
    brandContextHelp: "Link to a company to use their brand guidelines for AI content",
    setAsDefault: "Set as default account for new posts",
    validating: "Validating...",
    fillRequiredFields: "Please fill in all required fields",
    accountAdded: "Account added successfully!",
    accountUpdated: "Account updated successfully!",
    failedToAddAccount: "Failed to add account",
    failedToUpdateAccount: "Failed to update account",
    noAccountsConnected: "No Instagram accounts connected",
    addAccountToStart: "Add an account to start publishing",
    defaultLabel: "Default",
    setAsDefaultLabel: "Set as default",
    settingsLabel: "Settings",
    removeLabel: "Remove",
    editAccountLabel: "Edit Account:",
    editAccountDesc: "Update account settings. Leave token empty to keep current token.",
    displayNameLabel: "Display Name",
    newAccessToken: "New Access Token (optional)",
    keepCurrentToken: "Leave empty to keep current token",
    saveChanges: "Save Changes",
    deleteInstagramAccount: "Delete Instagram Account",
    deleteAccountConfirm: "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
    accountRemoved: "Account removed",
    failedToDeleteAccount: "Failed to delete account",
    // SlidePromptsEditor
    slidePromptDesc: "For each image, choose whether to generate with AI or upload your own.",
    autoGenerateAll: "Auto-Generate All",
    image: "Image",
    hook: "Hook",
    cta: "CTA",
    value: "Value",
    describeImage: "Describe what the image should show",
    hookDesc: "Attention-grabbing opening image",
    ctaDesc: "Call-to-action closing image",
    valueDesc: "Deliver value or information",
    slide: "Slide",
    enhanced: "Enhanced",
    uploaded: "Uploaded",
    imageSource: "Image Source",
    generateWithAi: "Generate with AI",
    uploadMyOwn: "Upload my own",
    enhancedPromptLabel: "Enhanced Prompt (used for image generation):",
    thisImageUsedForSlide: "This image will be used for slide",
    clickToUploadOrDrag: "Click to upload or drag & drop",
    slideUploadFormat: "PNG, JPG, WebP, GIF up to 50MB",
    textOverlay: "Text overlay",
    optionalTextOverlay: "(optional - shown on image)",
    textOverlayExample: "Transform Your Digital Presence",
    tipsForBetterImages: "Tips for better images:",
    tipSpecificColors: "Be specific about colors, lighting, and composition",
    tipDescribeMood: "Describe the mood or atmosphere you want",
    tipAvoidText: "Avoid including text in image descriptions (use text overlay instead)",
    tipEnhanceAi: 'Use "Enhance AI" to optimize your description for Nano Banana',
    // SlideEditor
    slideOf: "of",
    imageDescription: "Image Description",
    describeWhatYouWant: "Describe what you want to see in this image...",
    enhance: "Enhance",
    reset: "Reset",
    styleLabel: "Style",
    qualityLabel: "Quality",
    vibrant: "Vibrant",
    clean: "Clean",
    minimal: "Minimal",
    bold: "Bold",
    custom: "Custom",
    standard: "Standard",
    pro: "Pro",
    standardDesc: "1024px, fast",
    proDesc: "4096px, higher quality",
    generatingImage: "Generating...",
    generateImage: "Generate Image",
    regenerateImage: "Regenerate Image",
    uploadImage: "Upload Image",
    clickOrDragToUpload: "Click or drag to upload",
    slideEditorUploadFormat: "JPEG, PNG, WebP up to 50MB",
    textOverlayOptional: "Text Overlay (optional)",
    textOverlayPlaceholder: "Text to display on image...",
    shortTextOverlay: "Short text to overlay on the image (max 10 words)",
    defaultPromptPlaceholder: "Modern laptop on minimalist desk with plant...",
    // CaptionEditor
    captionTitle: "Caption",
    toneLabel: "Tone",
    lengthLabel: "Length",
    generatingCaption: "Generating...",
    generateCaptionAi: "Generate Caption with AI",
    captionTextLabel: "Caption Text",
    hashtagsLabel: "Hashtags",
    // Tone options
    toneMarketing: "Marketing",
    toneMarketingDesc: "Promotional, brand-focused",
    toneSales: "Sales",
    toneSalesDesc: "Conversion-oriented, persuasive",
    toneEducational: "Educational",
    toneEducationalDesc: "Informative, teaching",
    toneEntertaining: "Entertaining",
    toneEntertainingDesc: "Fun, engaging, relatable",
    toneInspirational: "Inspirational",
    toneInspirationalDesc: "Motivating, uplifting",
    toneConversational: "Conversational",
    toneConversationalDesc: "Casual, friendly chat",
    toneClean: "Clean",
    toneCleanDesc: "Professional, minimal",
    toneCustom: "Custom",
    toneCustomDesc: "Define your own tone",
    // Length options
    lengthShort: "Short",
    lengthShortDesc: "Quick, punchy",
    lengthShortWords: "50-80 words",
    lengthMedium: "Medium",
    lengthMediumDesc: "Balanced, detailed",
    lengthMediumWords: "120-180 words",
    lengthLong: "Long",
    lengthLongDesc: "Comprehensive",
    lengthLongWords: "220-280 words",
    // PostEditorHeader
    postTitlePlaceholder: "Post title...",
    loadingAccounts: "Loading...",
    selectAccountPlaceholder: "Select account",
    brandAiBadge: "Brand AI",
    brandAiTooltip: "AI will use {company}'s brand guidelines",
    saveDraft: "Save Draft",
    saveReady: "Save & Ready",
    // PostEditorDialog
    addPromptFirst: "Please add a prompt, text overlay, or title first",
    captionGenerated: "Caption generated successfully",
    captionFailed: "Failed to generate caption. Please try again.",
    // PostEditorRightPanel
    generatingImageText: "Generating image...",
    noImageYet: "No image yet",
    // ScheduleSection
    scheduleForLater: "Schedule for Later",
    leaveEmptyNoSchedule: "Leave empty to save without scheduling.",
    dateLabel: "Date",
    timeLabel: "Time",
    clearSchedule: "Clear schedule",
    // CarouselPreview
    noSlidesToPreview: "No slides to preview",
    sponsored: "Sponsored",
    generatingStatus: "Generating...",
    pendingStatus: "Pending",
    editImagePrompt: "Edit Image Prompt",
    imageUploaded: "Image uploaded",
    // Selectors
    instagramAccountLabel: "Instagram Account",
    numberOfSlides: "Number of Slides",
    imageQualityLabel: "Image Quality",
    visualStyleLabel: "Visual Style",
    captionToneLabel: "Caption Tone",
    // Toast messages
    defaultAccountSet: "is now the default account",
    failedSetDefault: "Failed to set default account",
    copiedToClipboard: "Copied to clipboard",
  },
  es: {
    title: "Planificación de Redes Sociales",
    subtitle: "Crea y gestiona publicaciones de carrusel de Instagram con IA",
    refresh: "Actualizar",
    createCarousel: "Crear Carrusel",
    create: "Crear",
    postStats: "Estadísticas de Publicaciones",
    scheduled: "Programadas",
    drafts: "Borradores",
    ready: "Listas",
    published: "Publicadas",
    scheduledPosts: "publicaciones programadas",
    draftPosts: "borradores",
    readyPosts: "publicaciones listas",
    publishedPosts: "publicaciones publicadas",
    tryAgain: "Reintentar",
    publishToInstagram: "Publicar en Instagram",
    publishNow: "Publicar Ahora",
    viewOnInstagram: "Ver en Instagram",
    preview: "Vista Previa",
    edit: "Editar",
    delete: "Eliminar",
    slides: "diapositivas",
    at: "a las",
    created: "Creado",
    noPostsYet: "No hay publicaciones aún. ¡Crea tu primer carrusel!",
    createPost: "Crear Publicación",
    deletePost: "Eliminar Publicación",
    deleteConfirm: "¿Estás seguro de que deseas eliminar esta publicación?",
    deleteCannotUndo: "Esta acción no se puede deshacer.",
    publishing: "Publicando en Instagram...",
    publishSuccess: "¡Publicado en Instagram!",
    publishFailed: "Error al publicar",
    failedPublish: "Error al publicar la publicación",
    viewOnIg: "Clic para ver en Instagram",
    cannotPublish: "No se puede publicar",
    noImages: "Esta publicación no tiene imágenes. Genera imágenes primero.",
    caption: "Descripción",
    spanish: "Español",
    english: "Inglés",
    posts: "Publicaciones",
    loadingPosts: "Cargando publicaciones",
    socialMediaPosts: "Publicaciones de redes sociales",
    untitledPost: "Publicación sin título",
    socialPostPreview: "Vista previa de publicación",
    previousMonth: "Mes anterior",
    nextMonth: "Mes siguiente",
    refreshPosts: "Actualizar publicaciones",
    publishConfirmDesc: "en Instagram ahora? Esto lo hará visible para tus seguidores.",
    publishLabel: "Publicar",
    postLive: "Tu publicación ya está en Instagram.",
    failedPublishToInstagram: "Error al publicar en Instagram",
    statusDraft: "Borrador",
    statusGenerating: "Generando",
    statusReady: "Lista",
    statusScheduled: "Programada",
    statusPublished: "Publicada",
    statusFailed: "Fallida",
    daySun: "Dom",
    dayMon: "Lun",
    dayTue: "Mar",
    dayWed: "Mié",
    dayThu: "Jue",
    dayFri: "Vie",
    daySat: "Sáb",
    monthJanuary: "Enero",
    monthFebruary: "Febrero",
    monthMarch: "Marzo",
    monthApril: "Abril",
    monthMay: "Mayo",
    monthJune: "Junio",
    monthJuly: "Julio",
    monthAugust: "Agosto",
    monthSeptember: "Septiembre",
    monthOctober: "Octubre",
    monthNovember: "Noviembre",
    monthDecember: "Diciembre",
    // InstagramAccountsManager
    instagramAccounts: "Cuentas de Instagram",
    addAccount: "Agregar Cuenta",
    addInstagramAccount: "Agregar Cuenta de Instagram",
    addAccountDesc: "Conecta una nueva cuenta de Instagram Business para publicar.",
    displayName: "Nombre de Visualización *",
    displayNamePlaceholder: "ej., Solariis, Banger.bio",
    businessAccountId: "ID de Cuenta de Instagram Business *",
    businessAccountIdPlaceholder: "ej., 17841400...",
    findInBusinessSuite: "Encuéntralo en Facebook Business Suite → Instagram → Configuración",
    accessToken: "Token de Acceso *",
    accessTokenPlaceholder: "Token de acceso de larga duración",
    contentLanguage: "Idioma del Contenido",
    brandContextCompany: "Contexto de Marca (Empresa)",
    selectCompanyPlaceholder: "Seleccionar empresa...",
    noCompanyDefaults: "Sin empresa (usar valores de Solariis)",
    brandContextHelp: "Vincula a una empresa para usar sus guías de marca para contenido IA",
    setAsDefault: "Establecer como cuenta predeterminada para nuevas publicaciones",
    validating: "Validando...",
    fillRequiredFields: "Por favor completa todos los campos requeridos",
    accountAdded: "¡Cuenta agregada exitosamente!",
    accountUpdated: "¡Cuenta actualizada exitosamente!",
    failedToAddAccount: "Error al agregar la cuenta",
    failedToUpdateAccount: "Error al actualizar la cuenta",
    noAccountsConnected: "Sin cuentas de Instagram conectadas",
    addAccountToStart: "Agrega una cuenta para comenzar a publicar",
    defaultLabel: "Predeterminada",
    setAsDefaultLabel: "Establecer como predeterminada",
    settingsLabel: "Configuración",
    removeLabel: "Eliminar",
    editAccountLabel: "Editar Cuenta:",
    editAccountDesc: "Actualizar configuración de cuenta. Deja el token vacío para mantener el actual.",
    displayNameLabel: "Nombre de Visualización",
    newAccessToken: "Nuevo Token de Acceso (opcional)",
    keepCurrentToken: "Dejar vacío para mantener el token actual",
    saveChanges: "Guardar Cambios",
    deleteInstagramAccount: "Eliminar Cuenta de Instagram",
    deleteAccountConfirm: "¿Estás seguro de que deseas eliminar \"{name}\"? Esta acción no se puede deshacer.",
    accountRemoved: "Cuenta eliminada",
    failedToDeleteAccount: "Error al eliminar la cuenta",
    // SlidePromptsEditor
    slidePromptDesc: "Para cada imagen, elige si generar con IA o subir la tuya.",
    autoGenerateAll: "Auto-Generar Todas",
    image: "Imagen",
    hook: "Gancho",
    cta: "CTA",
    value: "Valor",
    describeImage: "Describe lo que la imagen debe mostrar",
    hookDesc: "Imagen de apertura que llame la atención",
    ctaDesc: "Imagen de cierre con llamada a la acción",
    valueDesc: "Entregar valor o información",
    slide: "Diapositiva",
    enhanced: "Mejorado",
    uploaded: "Cargado",
    imageSource: "Fuente de Imagen",
    generateWithAi: "Generar con IA",
    uploadMyOwn: "Subir la mía",
    enhancedPromptLabel: "Prompt Mejorado (usado para generación de imagen):",
    thisImageUsedForSlide: "Esta imagen se usará para la diapositiva",
    clickToUploadOrDrag: "Clic para cargar o arrastra y suelta",
    slideUploadFormat: "PNG, JPG, WebP, GIF hasta 50MB",
    textOverlay: "Texto superpuesto",
    optionalTextOverlay: "(opcional - mostrado sobre la imagen)",
    textOverlayExample: "Transforma Tu Presencia Digital",
    tipsForBetterImages: "Consejos para mejores imágenes:",
    tipSpecificColors: "Sé específico sobre colores, iluminación y composición",
    tipDescribeMood: "Describe el ambiente o atmósfera que deseas",
    tipAvoidText: "Evita incluir texto en las descripciones de imagen (usa texto superpuesto)",
    tipEnhanceAi: 'Usa "Mejorar IA" para optimizar tu descripción para Nano Banana',
    // SlideEditor
    slideOf: "de",
    imageDescription: "Descripción de Imagen",
    describeWhatYouWant: "Describe lo que quieres ver en esta imagen...",
    enhance: "Mejorar",
    reset: "Restablecer",
    styleLabel: "Estilo",
    qualityLabel: "Calidad",
    vibrant: "Vibrante",
    clean: "Limpio",
    minimal: "Mínimo",
    bold: "Audaz",
    custom: "Personalizado",
    standard: "Estándar",
    pro: "Pro",
    standardDesc: "1024px, rápido",
    proDesc: "4096px, mayor calidad",
    generatingImage: "Generando...",
    generateImage: "Generar Imagen",
    regenerateImage: "Regenerar Imagen",
    uploadImage: "Subir Imagen",
    clickOrDragToUpload: "Clic o arrastra para cargar",
    slideEditorUploadFormat: "JPEG, PNG, WebP hasta 50MB",
    textOverlayOptional: "Texto Superpuesto (opcional)",
    textOverlayPlaceholder: "Texto a mostrar sobre la imagen...",
    shortTextOverlay: "Texto corto para superponer en la imagen (máx 10 palabras)",
    defaultPromptPlaceholder: "Laptop moderna en escritorio minimalista con planta...",
    // CaptionEditor
    captionTitle: "Descripción",
    toneLabel: "Tono",
    lengthLabel: "Longitud",
    generatingCaption: "Generando...",
    generateCaptionAi: "Generar Descripción con IA",
    captionTextLabel: "Texto de Descripción",
    hashtagsLabel: "Hashtags",
    // Tone options
    toneMarketing: "Marketing",
    toneMarketingDesc: "Promocional, enfocado en marca",
    toneSales: "Ventas",
    toneSalesDesc: "Orientado a conversión, persuasivo",
    toneEducational: "Educativo",
    toneEducationalDesc: "Informativo, didáctico",
    toneEntertaining: "Entretenido",
    toneEntertainingDesc: "Divertido, atractivo, cercano",
    toneInspirational: "Inspiracional",
    toneInspirationalDesc: "Motivador, edificante",
    toneConversational: "Conversacional",
    toneConversationalDesc: "Casual, charla amigable",
    toneClean: "Limpio",
    toneCleanDesc: "Profesional, mínimo",
    toneCustom: "Personalizado",
    toneCustomDesc: "Define tu propio tono",
    // Length options
    lengthShort: "Corto",
    lengthShortDesc: "Rápido, conciso",
    lengthShortWords: "50-80 palabras",
    lengthMedium: "Medio",
    lengthMediumDesc: "Equilibrado, detallado",
    lengthMediumWords: "120-180 palabras",
    lengthLong: "Largo",
    lengthLongDesc: "Completo",
    lengthLongWords: "220-280 palabras",
    // PostEditorHeader
    postTitlePlaceholder: "Título de la publicación...",
    loadingAccounts: "Cargando...",
    selectAccountPlaceholder: "Seleccionar cuenta",
    brandAiBadge: "Marca IA",
    brandAiTooltip: "La IA usará las guías de marca de {company}",
    saveDraft: "Guardar Borrador",
    saveReady: "Guardar y Lista",
    // PostEditorDialog
    addPromptFirst: "Por favor agrega un prompt, texto superpuesto o título primero",
    captionGenerated: "Descripción generada exitosamente",
    captionFailed: "Error al generar la descripción. Por favor intenta de nuevo.",
    // PostEditorRightPanel
    generatingImageText: "Generando imagen...",
    noImageYet: "Sin imagen aún",
    // ScheduleSection
    scheduleForLater: "Programar para Después",
    leaveEmptyNoSchedule: "Deja vacío para guardar sin programar.",
    dateLabel: "Fecha",
    timeLabel: "Hora",
    clearSchedule: "Limpiar programación",
    // CarouselPreview
    noSlidesToPreview: "Sin diapositivas para previsualizar",
    sponsored: "Patrocinado",
    generatingStatus: "Generando...",
    pendingStatus: "Pendiente",
    editImagePrompt: "Editar Prompt de Imagen",
    imageUploaded: "Imagen cargada",
    // Selectors
    instagramAccountLabel: "Cuenta de Instagram",
    numberOfSlides: "Número de Diapositivas",
    imageQualityLabel: "Calidad de Imagen",
    visualStyleLabel: "Estilo Visual",
    captionToneLabel: "Tono de Descripción",
    // Toast messages
    defaultAccountSet: "es ahora la cuenta predeterminada",
    failedSetDefault: "Error al establecer cuenta predeterminada",
    copiedToClipboard: "Copiado al portapapeles",
  },
};
